import React from 'react';

import { Box, Typography } from '@mui/material';

import ScorePill from './ScorePill';
import { SEVERITY_COLORS } from './constants';

interface NoRatesRingProps {
  daysWithoutRates: number;
}

export default function NoRatesRing({ daysWithoutRates }: NoRatesRingProps) {
  const ringColor = daysWithoutRates === 0 ? SEVERITY_COLORS.in_parity : SEVERITY_COLORS.severe;
  const rating = daysWithoutRates === 0 ? 'GOOD' : 'CRITICAL';
  const alertText =
    daysWithoutRates === 0
      ? 'GOOD: LE have rates on all days covered by competitors'
      : `CRITICAL: ${daysWithoutRates} dates where LE has no rates but competitors do`;
  const ring = (
    <Box sx={{ flexShrink: 0, textAlign: 'center', position: 'relative', width: 140, height: 140 }}>
      <svg width="140" height="140" viewBox="0 0 140 140">
        <circle cx="70" cy="70" r={58} fill="none" stroke="#e0e0e0" strokeWidth="12" />
        <circle cx="70" cy="70" r={58} fill="none" stroke={ringColor} strokeWidth="12" />
      </svg>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 140,
          height: 140,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" color="textSecondary">
          No Rates
        </Typography>
        <Typography sx={{ fontSize: 36, fontWeight: 700, color: ringColor }}>{daysWithoutRates}</Typography>
      </Box>
    </Box>
  );
  return <ScorePill ring={ring} rating={rating} alertText={alertText} />;
}
